import { apiClient } from "@/lib/apiClient";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

export const fetchListQuestions = createAsyncThunk(
  "question/fetchQuestion",
  async (_, { rejectWithValue }) => {
    try {
      const res = await apiClient.get("/client/gamequestion");
      if (res.code !== 200 || res.isError) {
        return rejectWithValue(res.message);
      }
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const startGameQuestion = createAsyncThunk(
  "question/startQuestion",
  async (_, { rejectWithValue }) => {
    try {
      const res = await apiClient.put("/client/gamequestion/start");

      if (res.code !== 200 || res.isError) {
        return rejectWithValue(res.message);
      }
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const createListGameQuestion = createAsyncThunk(
  "question/createListQuestion",
  async (_, { rejectWithValue }) => {
    try {
      const res = await apiClient.put("/client/gamequestion");

      if (res.code !== 200 || res.isError) {
        return rejectWithValue(res.message);
      }
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const updateGameQuestion = createAsyncThunk(
  "question/updateQuestion",
  async (body, { rejectWithValue }) => {
    try {
      const res = await apiClient.put("/client/gamequestion/update", body);

      if (res.code !== 200 || res.isError) {
        return rejectWithValue(res.message);
      }
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const fetchHistoryAnswer = createAsyncThunk(
  "question/historyAnswer",
  async (_, { rejectWithValue }) => {
    try {
      const res = await apiClient.get("/client/gamequestion/history-answer");
      if (res.code !== 200 || res.isError) {
        return rejectWithValue(res.message);
      }
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const fetchQuestionInfo = createAsyncThunk(
  "question/questionInfo",
  async (_, { rejectWithValue }) => {
    try {
      const res = await apiClient.get("/client/gamequestion/info");
      if (res.code !== 200 || res.isError) {
        return rejectWithValue(res.message);
      }
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const fetchTurnSpin = createAsyncThunk(
  "question/turnSpin",
  async (_, { rejectWithValue }) => {
    try {
      const res = await apiClient.get("/client/event/info");
      if (res.code !== 200 || res.isError) {
        return rejectWithValue(res.message);
      }
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const fetchTurnQuesstion = createAsyncThunk(
  "question/turnQuestion",
  async (_, { rejectWithValue }) => {
    try {
      const res = await apiClient.get("/client/gamequestion/check-turn");
      if (res.code !== 200 || res.isError) {
        return rejectWithValue(res.message);
      }
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const updateQuestionPrize = createAsyncThunk(
  "question/prizeQestion",
  async (_, { rejectWithValue }) => {
    try {
      const res = await apiClient.put("/client/gamequestion/update-prize");
      if (res.code !== 200 || res.isError) {
        return rejectWithValue(res.message);
      }
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const initValues = {
  suggestionLetters: [
    {
      value: "A",
      used: false,
    },
    {
      value: "B",
      used: false,
    },
    {
      value: "C",
      used: true,
    },
    {
      value: "D",
      used: false,
    },
    {
      value: "E",
      used: false,
    },
    {
      value: "F",
      used: false,
    },
    {
      value: "R",
      used: false,
    },
    {
      value: "T",
      used: false,
    },
    {
      value: "Y",
      used: true,
    },
    {
      value: "U",
      used: false,
    },
    {
      value: "I",
      used: false,
    },
    {
      value: "P",
      used: false,
    },
    {
      value: "O",
      used: false,
    },
    {
      value: "H",
      used: false,
    },
    {
      value: "K",
      used: false,
    },
    {
      value: "L",
      used: false,
    },
  ],
};

const initialState = {
  isShowGameGuess: false,
  stepGame: 1,
  isFinish: false,
  suggestionLetters: initValues.suggestionLetters,
  selectedSuggestionChar: null,
  loading: false,
  listQuestions: [],
  questionReading: null,
  answerChars: [],
  chars: Array(12).fill(""),
  listAswer: [],
  loadingAnswer: false,
  turn: 0,
  turnQuestion: null,
  prize: [],
  timePlay: null,
  hintIndexes: [],
};

export const gamesSlice = createSlice({
  name: "games",
  initialState,
  reducers: {
    setShowGame: (state, action) => {
      state.isShowGameGuess = action.payload;
    },
    setStepGame: (state, action) => {
      state.stepGame = action.payload ?? 1;
    },
    setIsFinish: (state, action) => {
      state.isFinish = action.payload;
    },
    setSuggestionLetters: (state, action) => {
      state.suggestionLetters = action.payload;
    },
    resetSuggestionLetters: (state) => {
      state.suggestionLetters = initValues.suggestionLetters;
    },
    setChars: (state, action) => {
      state.chars = action.payload;
    },
    resetChars: (state) => {
      state.chars = Array(12).fill("");
    },
    markSuggestionCharUsed: (state, action) => {
      const char = action.payload;
      const item = state.suggestionLetters.find(
        (i) => i.value === char && !i.used
      );
      if (item) {
        item.used = true;
      }
    },
    clearSelectedSuggestionChar: (state) => {
      state.selectedSuggestionChar = null;
    },
    setQuestionReading: (state, action) => {
      state.questionReading = action.payload;
    },
    resetChars: (state, action) => {
      const length = action.payload || 7;
      state.chars = Array(length).fill("");
      state.focusedIndex = 0;
    },
    selectSuggestionChar: (state, action) => {
      state.selectedSuggestionChar = action.payload;
    },
    setHintIndex: (state, action) => {
      state.hintIndexes = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchListQuestions.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchListQuestions.fulfilled, (state, action) => {
        state.loading = false;
        state.listQuestions = action?.payload?.data;
      })
      .addCase(fetchListQuestions.rejected, (state) => {
        state.loading = false;
      })
      .addCase(createListGameQuestion.pending, (state) => {
        state.loading = true;
      })
      .addCase(createListGameQuestion.fulfilled, (state, action) => {
        state.loading = false;
        state.listQuestions = action?.payload?.data;
      })
      .addCase(createListGameQuestion.rejected, (state) => {
        state.loading = false;
      })
      .addCase(fetchHistoryAnswer.pending, (state) => {
        state.loadingAnswer = true;
      })
      .addCase(fetchHistoryAnswer.fulfilled, (state, action) => {
        state.loadingAnswer = false;
        state.listAswer = action.payload?.data;
      })
      .addCase(fetchHistoryAnswer.rejected, (state) => {
        state.loadingAnswer = false;
      })
      .addCase(fetchQuestionInfo.pending, (state) => {
        state.loadingAnswer = true;
      })
      .addCase(fetchQuestionInfo.fulfilled, (state, action) => {
        state.isFinish = action.payload?.data?.isJoin;
        // state.isFinish = false;
        state.loadingAnswer = false;
        state.listAswer = action.payload?.data?.answers;
        // state.listQuestions = action.payload?.data?.answers;
        state.timePlay =
          new Date(action.payload?.data?.finishedAt) -
          new Date(action.payload?.data?.startedAt);
      })
      .addCase(fetchQuestionInfo.rejected, (state) => {
        state.loadingAnswer = false;
      })
      .addCase(fetchTurnSpin.fulfilled, (state, action) => {
        state.turn = action.payload?.data;
      })
      .addCase(fetchTurnQuesstion.fulfilled, (state, action) => {
        state.turnQuestion = action.payload?.data || 0;
      })
      .addCase(updateQuestionPrize.fulfilled, (state, action) => {
        state.prize = action.payload?.data;
      });
  },
});

export const {
  setShowGame,
  setStepGame,
  setIsFinish,
  setSuggestionLetters,
  selectSuggestionChar,
  clearSelectedSuggestionChar,
  setChars,
  resetSuggestionLetters,
  resetChars,
  setHintIndex,
} = gamesSlice.actions;

export default gamesSlice.reducer;
